import { defineStore } from 'pinia';
import { ref, reactive } from 'vue';
export const useStoreData = defineStore({
	id: 'vrp_store_data',
	state: () => ({
		//로그인 이후 표출될 회사 관련 정보
		office_info: ref({
			office_name: 'test 회사이름',
			office_payment_status: '베타서비스 이용중',
		}),
		//공지사항 구조체 - 임시로 만듬
		noticeList: ref([]),
		dashboard_data: reactive({
			daily_status: {
				daily_capacity: 0,
				date: '',
				delivered_task_cnt: 0,
				delivery_progress_rate: 0,
				job_ids: [],
				series_cnt: 0,
				task_cnt: 0,
				undelivered_task_cnt: 0,
			},
			job_infos: [],
			member_info: {
				login_count: 0,
				member_name: '',
			},
		}),
		dashboard_today_info: reactive({
			today_route_count: 4,
			today_delivery_count: 2,
			today_amount: 243,
			today_process: 14,
			today_complete_count: 23,
			today_wait_count: 44,
		}),
		driver_manage_data: reactive({
			count_info: { total_count: 7, fix_count: 3, temp_count: 4 },
			driver_list: [
				{
					driver_id: 1,
					driver_name: '채기사채기사채기사채',
					vehicle_weight: '1톤',
					vehicle_type: '카고',
					driver_type: '고정',
					region: ['구리', '남양주'],
					hex: '#4CBDE5',
				},
			],
		}),
		/*--------------------경로 만들기에 사용되는 ref data --------------------*/
		isTest: ref(false),
		isFromFixHistory: ref(false),
		select_drivers: reactive([]), //기사 선택 모달에서 사용되는 데이터(고정경로도 공통통)
		opt_set_time: ref(null), //배송경로 만들기 시간 설정 데이터
		uploaded_excel_data: ref(null), //엑셀 업로드 데이터
		select_sheet_data: ref(null), //엑셀 선택한 시트 데이터
		select_sheet_row_index: ref(0), //엑셀 선택한 행 인덱스
		select_addr_data: ref(null), //엑셀 선택한 주소 데이터
		addr_refine_result_data: ref(null), //headerdetail 모달에서 세팅, selectaddr 모달에서 사용
		route_plan_opt_job_info: ref(null), //selectaddr 모달에서 세팅, edit 페이지 에서 사용
		route_plan_option_job_info: ref(null), // option 페이지에서 사용되는 데이터
		opt_result_data: ref(null), //배송 최적화 완료 데이터
		opt_result_copy_data: ref(null),
		opt_result_before_data: ref(null),
		unassign_job_data: ref(null), //미배차 지점 데이터
		/*--------------------고정 경로 만들기에 사용되는 ref data --------------------*/
		fix_isFromFixHistory: ref(false),
		fix_opt_set_time: ref(null), //배송경로 만들기 시간 설정 데이터
		fix_uploaded_excel_data: ref(null), //고정경로 엑셀 업로드 데이터
		fix_select_sheet_data: ref(null), //고정경로 엑셀 선택한 시트 데이터
		fix_select_sheet_row_index: ref(0), //고정경로 엑셀 선택한 행 인덱스
		fix_select_addr_data: ref(null), //고정경로 엑셀 선택한 주소 데이터
		fix_addr_refine_result_data: ref(null), //headerdetail 모달에서 세팅, selectaddr 모달에서 사용
		fix_route_plan_opt_job_info: ref(null), //selectaddr 모달에서 세팅, option 페이지 에서 사용
		fix_opt_result_data: ref(null), //배송 최적화 완료 데이터
		fix_opt_result_copy_data: ref(null),
		fix_opt_result_before_data: ref(null),
		/*--------------------기타 ref data --------------------*/
		delivery_history_option: ref(null), //배송내역 - 검색 옵션값 기억
		delivery_history_data: ref(null), //배송내역 데이터
		delivery_job_data: ref(null), //배송내역 상세(job) 데이터
		isRefreshQueryMember: ref(false), //계정관리 Refresh
	}),
	actions: {
		...createSetResetActions([
			'opt_set_time',
			'uploaded_excel_data',
			'select_sheet_data',
			'select_sheet_row_index',
			'select_addr_data',
			'addr_refine_result_data',
			'route_plan_opt_job_info',
			'route_plan_option_job_info',
			'select_drivers',
			'opt_result_data',
			'opt_result_copy_data',
			'opt_result_before_data',
			'unassign_job_data',
			'fix_opt_set_time',
			'fix_uploaded_excel_data',
			'fix_select_sheet_data',
			'fix_select_sheet_row_index',
			'fix_select_addr_data',
			'fix_addr_refine_result_data',
			'fix_route_plan_opt_job_info',
			'fix_opt_result_data',
			'fix_opt_result_copy_data',
			'fix_opt_result_before_data',
			'delivery_history_option',
			'delivery_history_data',
			'delivery_job_data',
			'dashboard_data',
		]),
		//add 페이지 에서 주소 선택 이후 edit 페이지에서 사용할 데이터 세팅
		pushRoutePlanOptJobInfo(data) {
			if (!this.route_plan_opt_job_info) {
				this.route_plan_opt_job_info = [];
			}
			// num 값 자동 할당
			if (this.route_plan_opt_job_info.length === 0) {
				data.num = 1;
			} else {
				const maxNum = this.route_plan_opt_job_info.reduce(
					(max, item) => Math.max(max, item.num || 0),
					0,
				);
				data.num = maxNum + 1;
			}
			this.route_plan_opt_job_info.push(data);
		},
	},
});
//set, reset data helper
function createSetResetActions(keys) {
	const actions = {};
	keys.forEach(key => {
		const pascalKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
		const capitalizedKey =
			pascalKey.charAt(0).toUpperCase() + pascalKey.slice(1);
		actions[`set${capitalizedKey}`] = function (data) {
			this[key] = data;
		};
		actions[`reset${capitalizedKey}`] = function () {
			if (this[key]) deepReset(this[key]);
			this[key] = key.endsWith('row_index')
				? 0
				: key.includes('isFromFixHistory')
					? false
					: null;
		};
	});
	return actions;
}
// data reset helper
function deepReset(target) {
	if (Array.isArray(target)) {
		target.forEach(item => {
			if (typeof item === 'object' && item !== null) {
				deepReset(item);
			}
		});
		target.length = 0;
	} else if (typeof target === 'object' && target !== null) {
		for (const key in target) {
			if (typeof target[key] === 'object' && target[key] !== null) {
				deepReset(target[key]);
			}
			target[key] = null;
		}
	} else {
		target = null;
	}
}
